import { lazy } from 'react';

const EnvelopesListPage = lazy(() => import('@/pages/envelopes/EnvelopesListPage'));
const EnvelopeDetailPage = lazy(() => import('@/pages/envelopes/EnvelopeDetailPage'));
const EnvelopeCreatePage = lazy(() => import('@/pages/envelopes/EnvelopeCreatePage'));
const EnvelopeAdditionalDocumentPage = lazy(() => import('@/pages/envelopes/EnvelopeAdditionalDocumentPage'));

export const envelopeRoutes = [
    {
        path: 'approvals',
        element: <EnvelopesListPage />,
    },
    {
        path: 'approvals/create',
        element: <EnvelopeCreatePage />,
    },
    {
        path: 'approvals/:id',
        element: <EnvelopeDetailPage />,
    },
    {
        path: 'approvals/:id/additional-document',
        element: <EnvelopeAdditionalDocumentPage />,
    },
];
